"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const index_1 = __importDefault(require("../../icon/index"));
const Tooltip_1 = __importDefault(require("../../../client/reusable_components/Tooltip"));
const layout_css_1 = __importDefault(require("../../../styles/global_ui/layout.css"));
const util_css_1 = __importDefault(require("../../../styles/global_ui/util.css"));
const pro_badge_css_1 = __importDefault(require("./pro_badge.css"));
const c = {
    container: ({ size }) => [
        layout_css_1.default.flexCenterCenter,
        util_css_1.default.borderRadiusRound,
        pro_badge_css_1.default.badge,
        size === 'small' ? pro_badge_css_1.default.sContainer : '',
        size === 'medium' ? pro_badge_css_1.default.mContainer : '',
        size === 'large' ? pro_badge_css_1.default.lContainer : '',
    ].join(' '),
    logo: ({ size }) => [
        util_css_1.default.circle,
        layout_css_1.default.flex,
        pro_badge_css_1.default.hacksterLogo,
        size === 'small' ? pro_badge_css_1.default.small : '',
        size === 'medium' ? pro_badge_css_1.default.medium : '',
        size === 'large' ? pro_badge_css_1.default.large : '',
    ].join(' '),
    text: ({ size }) => [
        pro_badge_css_1.default.text,
        size === 'small' ? pro_badge_css_1.default.sText : '',
        size === 'medium' ? pro_badge_css_1.default.mText : '',
        size === 'large' ? pro_badge_css_1.default.lText : '',
    ].join(' '),
};
const sizeMap = {
    small: 6,
    medium: 10,
    large: 24,
};
const ProBadge = ({ contentType, size, tooltipProps, classList }) => (
// @ts-expect-error TODO: Convert Tooltip to TS
react_1.default.createElement(Tooltip_1.default, { align: "center", collisionPadding: 15, content: `This ${contentType || 'content'} is for PRO contributors only`, onClick: (e) => {
        e.stopPropagation(); // Wrapper has redirect to contest.
        window.location.assign('/pro');
    }, side: "top", sideOffset: 5, variant: "secondary", ...tooltipProps },
    react_1.default.createElement("div", { className: `${c.container({ size })} ${classList?.container}` },
        react_1.default.createElement("div", { className: `${c.logo({ size })} ${classList?.logo}` },
            react_1.default.createElement(index_1.default, { name: "hackster", size: sizeMap[size] || 10 })),
        react_1.default.createElement("div", { className: c.text({ size }) }, "PRO"))));
exports.default = ProBadge;
